module.exports = __webpack_public_path__ + "static/media/9DESA21.47df5a27.jpg";